import { SPATEM } from './spatemsTypes';
import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
};

export const spatemsAdapter = createEntityAdapter({
  selectId: (el: SPATEM) => el.id,
});

const spatemsReducer = createSlice({
  name: 'spatems',
  initialState: spatemsAdapter.getInitialState(initialState),
  reducers: {
    spatemsRequest: (state, _action: PayloadAction<{ roadSegmentIds: string[] }>) => {
      state.loading = true;
    },
    spatemsResponse: (state, action: PayloadAction<SPATEM[]>) => {
      if (state.loading) {
        spatemsAdapter.setAll(state, action.payload);
        state.loading = false;
      }
    },
    spatemsAddOne: spatemsAdapter.addOne,
    spatemsAddMany: spatemsAdapter.addMany,
    spatemsUpdate: spatemsAdapter.updateOne,
    spatemsRemove: spatemsAdapter.removeOne,
    spatemsUpsertOne: spatemsAdapter.upsertOne,
  },
});

export default spatemsReducer;

